<!-- src\components\admin\dashboard\StatsCards.vue -->
<template>
	<div class="admn_stats-cards">
		<!-- Всего студентов -->
		<div class="stat-card stat-card--blue">
			<div class="stat-card__content">
				<div class="stat-card__value">{{ stats.totalStudents.value }}</div>
				<div class="stat-card__label">{{ stats.totalStudents.label }}</div>
			</div>
			<div class="stat-card__icon">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
					<path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"/>
					<circle cx="9" cy="7" r="4"/>
					<path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"/>
					<path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"/>
				</svg>
			</div>
		</div>

		<!-- Активных студентов (реально заходили) -->
		<div class="stat-card stat-card--green">
			<div class="stat-card__content">
				<div class="stat-card__value">{{ stats.activeStudents.value }}</div>
				<div class="stat-card__label">{{ stats.activeStudents.label }}</div>
				<div class="stat-card__sublabel">заходили в систему</div>
			</div>
			<div class="stat-card__icon">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
					<path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18457 2.99721 7.13633 4.39828 5.49707C5.79935 3.85782 7.69279 2.71538 9.79619 2.24015C11.8996 1.76491 14.1003 1.98234 16.07 2.86"/>
					<path d="M22 4L12 14.01L9 11.01"/>
				</svg>
			</div>
		</div>

		<!-- Всего курсов -->
		<div class="stat-card stat-card--gold">
			<div class="stat-card__content">
				<div class="stat-card__value">{{ stats.totalCourses.value }}</div>
				<div class="stat-card__label">{{ stats.totalCourses.label }}</div>
			</div>
			<div class="stat-card__icon">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
					<path d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z"/>
					<path d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z"/>
				</svg>
			</div>
		</div>

		<!-- Активные курсы (опубликованные) -->
		<div class="stat-card stat-card--purple">
			<div class="stat-card__content">
				<div class="stat-card__value">{{ stats.activeCourses.value }}</div>
				<div class="stat-card__label">{{ stats.activeCourses.label }}</div>
				<div class="stat-card__sublabel">опубликованы</div>
			</div>
			<div class="stat-card__icon">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
					<path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20"/>
					<path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z"/>
					<path d="M9 6H15M9 10H13"/>
				</svg>
			</div>
		</div>

		<!-- Загрузка -->
		<div v-if="loading" class="stats-loading">
			<div class="spinner"></div>
		</div>
	</div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { getDashboardStats } from '@/services/dashboard'

const loading = ref(true)
const stats = reactive({
	totalStudents: { value: 0, label: 'Всего студентов' },
	activeStudents: { value: 0, label: 'Активных студентов' },
	totalCourses: { value: 0, label: 'Всего курсов' },
	activeCourses: { value: 0, label: 'Активные курсы' },
})

const fetchStats = async () => {
	try {
		loading.value = true
		const response = await getDashboardStats()
		const data = response?.data || response
		
		if (data?.totalStudents) {
			stats.totalStudents.value = data.totalStudents.value ?? 0
		}
		if (data?.activeStudents) {
			stats.activeStudents.value = data.activeStudents.value ?? 0
		}
		if (data?.totalCourses) {
			stats.totalCourses.value = data.totalCourses.value ?? 0
		}
		if (data?.activeCourses) {
			stats.activeCourses.value = data.activeCourses.value ?? 0
		}
	} catch (error) {
		console.error('[StatsCards] Ошибка загрузки статистики:', error)
	} finally {
		loading.value = false
	}
}

onMounted(fetchStats)
</script>

<style scoped>
.admn_stats-cards {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 12px;
	position: relative;
	flex-shrink: 0;
}

/* Базовые стили карточки */
.stat-card {
	background: #ffffff;
	border-radius: 12px;
	padding: 14px 16px;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	transition: all 0.3s ease;
	position: relative;
	overflow: hidden;
}

.stat-card::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 4px;
}

.stat-card:hover {
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

/* Цветовые варианты */
.stat-card--blue::before {
	background: linear-gradient(90deg, #3b82f6, #60a5fa);
}

.stat-card--green::before {
	background: linear-gradient(90deg, #22c55e, #4ade80);
}

.stat-card--gold::before {
	background: linear-gradient(90deg, #f59e0b, #fbbf24);
}

.stat-card--purple::before {
	background: linear-gradient(90deg, #a855f7, #c084fc);
}

/* Контент карточки */
.stat-card__content {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.stat-card__value {
	font-family: 'Poppins', sans-serif;
	font-size: 22px;
	font-weight: 700;
	color: #1e293b;
	line-height: 1.1;
}

.stat-card__label {
	font-family: 'Poppins', sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #64748b;
}

.stat-card__sublabel {
	font-family: 'Poppins', sans-serif;
	font-size: 12px;
	color: #94a3b8;
}

/* Иконка */
.stat-card__icon {
	width: 44px;
	height: 44px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	transition: transform 0.3s ease;
}

.stat-card:hover .stat-card__icon {
	transform: scale(1.05);
}

.stat-card__icon svg {
	width: 22px;
	height: 22px;
	color: white;
}

.stat-card--blue .stat-card__icon {
	background: linear-gradient(135deg, #3b82f6, #2563eb);
}

.stat-card--green .stat-card__icon {
	background: linear-gradient(135deg, #22c55e, #16a34a);
}

.stat-card--gold .stat-card__icon {
	background: linear-gradient(135deg, #f59e0b, #d97706);
}

.stat-card--purple .stat-card__icon {
	background: linear-gradient(135deg, #a855f7, #9333ea);
}

/* Загрузка */
.stats-loading {
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.9);
	backdrop-filter: blur(4px);
	border-radius: 16px;
}

.spinner {
	width: 40px;
	height: 40px;
	border: 3px solid #e2e8f0;
	border-top-color: #3b82f6;
	border-radius: 50%;
	animation: spin 0.8s linear infinite;
}

@keyframes spin {
	to { transform: rotate(360deg); }
}

/* Адаптивность */
@media (min-width: 769px) and (max-width: 1366px) {
	.admn_stats-cards {
		grid-template-columns: repeat(4, 1fr);
	}
}

@media (min-width: 1367px) and (max-width: 1600px) {
	.admn_stats-cards {
		grid-template-columns: repeat(4, 1fr);
	}
}

@media (min-width: 1601px) and (max-width: 1800px) {
	.admn_stats-cards {
		grid-template-columns: repeat(4, 1fr);
	}
}

@media (max-width: 768px) {
	.admn_stats-cards {
		grid-template-columns: 1fr;
	}
	
	.stat-card {
		padding: 20px;
	}
	
	.stat-card__value {
		font-size: 28px;
	}
}
</style>
